module.exports = __webpack_public_path__ + "1791188489487/images/no-data.6265e46.svg";